// Coordinates from whatever an admin pastes: a Google Maps URL, or plain "lat, lng".
//
// Google Maps URL forms, most precise first:
//   …/data=!3d17.385044!4d78.486671           exact pin of a place
//   …?q=17.385,78.486  ?query=  ?ll=  ?center=  ?destination=
//   …/place/17.385,78.486   …/search/17.385,+78.486
//   …/@17.385044,78.486671,15z                 map centre (close to, not exactly, the pin)
// Short share links (maps.app.goo.gl/…) carry no coordinates; they are resolved
// by the server first (isShortMapsLink).

const NUM = "(-?\\d{1,3}(?:\\.\\d+)?)";
const PAIR = new RegExp(`^\\s*${NUM}\\s*[,\\s]\\s*\\+?${NUM}\\s*$`);

const valid = (lat, lng) => Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180 && !(lat === 0 && lng === 0);

const round6 = (n) => Math.round(n * 1e6) / 1e6;

function pair(text) {
  const m = PAIR.exec(text || "");
  if (!m) return null;
  const lat = Number(m[1]);
  const lng = Number(m[2]);
  return valid(lat, lng) ? { lat: round6(lat), lng: round6(lng) } : null;
}

export function isShortMapsLink(text) {
  try {
    const u = new URL(text.trim());
    return u.protocol === "https:" && ["maps.app.goo.gl", "goo.gl"].includes(u.hostname.toLowerCase());
  } catch {
    return false;
  }
}

export function parseCoordinates(input) {
  const text = (input || "").trim();
  if (!text) return null;

  const plain = pair(text);
  if (plain) return plain;

  let decoded = text;
  try {
    decoded = decodeURIComponent(text.replace(/\+/g, " "));
  } catch {
    /* keep raw text */
  }

  // exact place pin
  const pin = new RegExp(`!3d${NUM}!4d${NUM}`).exec(decoded);
  if (pin) {
    const p = pair(`${pin[1]},${pin[2]}`);
    if (p) return p;
  }

  // query parameters
  try {
    const u = new URL(text);
    for (const key of ["q", "query", "ll", "center", "destination", "daddr", "sll"]) {
      const p = pair(u.searchParams.get(key));
      if (p) return p;
    }
  } catch {
    /* not a URL */
  }

  // /place/lat,lng or /search/lat,lng
  const path = new RegExp(`/(?:place|search|dir)/${NUM}\\s*,\\s*\\+?${NUM}`).exec(decoded);
  if (path) {
    const p = pair(`${path[1]},${path[2]}`);
    if (p) return p;
  }

  // map centre
  const at = new RegExp(`@${NUM},${NUM}`).exec(decoded);
  if (at) {
    const p = pair(`${at[1]},${at[2]}`);
    if (p) return p;
  }
  return null;
}

// Google Maps search for the typed address (or the current coordinates)
export function googleMapsSearchUrl({ lat, lng, address }) {
  const query = lat !== "" && lng !== "" && lat != null && lng != null ? `${lat},${lng}` : address;
  return query ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}` : "https://www.google.com/maps";
}
